
import { useDispatch, useSelector} from "react-redux";
import { createFailureAction, createSetNetworkAction, createSetServerDetails, createSetViewAction, createTryAgainAction} from "shared/state/reducer";
import { useDedupEffect } from "@npd-ng/adp-component-library";
import { IADPState } from "shared/typings/AppStateTypes";
import { environment } from "../util";
export function useNetworkStatus() {
  const dispatch = useDispatch();    
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );   
  useDedupEffect(() => {
    const handleOnline = () => {
      dispatch(createSetNetworkAction("Connected"));
      dispatch(createTryAgainAction());
    }
    const handleOffline = () => {
      dispatch(createSetNetworkAction("N/A"));
      dispatch(createFailureAction("NoInternetConnectionDetected"));
    }
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    navigator.onLine ? handleOnline : handleOffline;
    dispatch(createSetServerDetails(environment.resolveApiDomain(state.appState.configuration)))
    console.log("[NetworkStatus]","device is ", navigator.onLine ?  "online" : "offline");
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  },[])
  useDedupEffect(() => {
    if(state.sessionState.tryAgainAfterFailure){
      console.log("state.sessionState.tryAgainAfterFailure")
      if(navigator.onLine){
        state.sessionState.lastKnownGoodState ?  
        dispatch(createSetViewAction(state.sessionState.lastKnownGoodState)): 
        window.location.reload()
      }
      else {
        dispatch(createSetNetworkAction("N/A"));
        dispatch(createFailureAction("NoInternetConnectionDetected"));
      }
      
    } 
  },[state.sessionState.tryAgainAfterFailure]);
 }


